import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import { TextField } from 'formik-material-ui';

import { Field } from 'formik';

export default function PaymentForm() {
  return (
    <React.Fragment>
      <Typography variant="h6" gutterBottom>
        What do you plan on using the site for?
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12}>
        <Field name="siteDetails" 
          label="Tell us about your site" 
          placeholder="Site Name" 
          component={TextField} 
           
          required
          />
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
